// import React from "react";
// import "../styles/EngineeringResults.css";

// const EngineeringResults = () => {
//   return (

//      <section class="section-impact" id="impact">
//         <div class="container">
//             <div class="section-header text-center">
//                 <h2 class="section-tag">ENGINEERING RESULTS</h2>
//                 <h3>Projected Business Impact</h3>
//             </div>

//             <div class="impact-grid">
//                 <div class="impact-card impact-card-green">
//                     <div class="stat-label text-green">SYSTEM EFFICIENCY</div>
//                     <div class="metric-text">PEAK PERFORMANCE</div>
//                     <h4>Performance & Scalability</h4>
//                     <p>Sub-second response times globally. Our updates ensure your app remains resilient under peak traffic loads.</p>
//                 </div>

//                 <div class="impact-card impact-card-red">
//                     <div class="stat-label text-red">OPEX REDUCTION</div>
//                     <div class="metric-text">MAXIMUM ROI</div>
//                     <h4>Return on Investment</h4>
//                     <p>Eliminate monolithic infrastructure waste. We optimize resource consumption through intelligent orchestration.</p>
//                 </div>

//                 <div class="impact-card impact-card-blue">
//                     <div class="stat-label text-blue">GLOBAL UPTIME</div>
//                     <div class="metric-text">ZERO DOWNTIME</div>
//                     <h4>Business Continuity</h4>
//                     <p>Self-healing, geo-distributed architectures that keep your application active during regional failures.</p>
//                 </div>
//             </div>
//         </div>
//     </section>
//   );
// };

// export default EngineeringResults;









import React from "react";
import "../styles/EngineeringResults.css";

const EngineeringResults = () => {
  return (
     <section className="section-impact" id="impact">
        <div className="container">
            <div className="section-header text-center">
                <h2 className="section-tag">ENGINEERING RESULTS</h2>
                <h3>Projected Business Impact</h3>
            </div>

            <div className="impact-grid">
                <div className="impact-card impact-card-green">
                    <div className="stat-label text-green">SYSTEM EFFICIENCY</div>
                    <div className="metric-text">PEAK PERFORMANCE</div>
                    <h4>Performance & Scalability</h4>
                    <p>Sub-second response times globally. Our updates ensure your app remains resilient under peak traffic loads.</p>
                </div>

                {/* Updated Second Card to Purple */}
                <div className="impact-card impact-card-purple">
                    <div className="stat-label text-purple">OPEX REDUCTION</div>
                    <div className="metric-text">MAXIMUM ROI</div>
                    <h4>Return on Investment</h4>
                    <p>Eliminate monolithic infrastructure waste. We optimize resource consumption through intelligent orchestration.</p>
                </div>

                <div className="impact-card impact-card-blue">
                    <div className="stat-label text-blue">GLOBAL UPTIME</div>
                    <div className="metric-text">ZERO DOWNTIME</div>
                    <h4>Business Continuity</h4>
                    <p>Self-healing, geo-distributed architectures that keep your application active during regional failures.</p>
                </div>
            </div>
        </div>
    </section>
  );
};

export default EngineeringResults;